import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseValidateEmail: ReponseEnveloppe<boolean> = {
    reponse: true
}
